export type ManualInputVersion = 'v1' | 'v2' | 'v3';

export const getManualInputVersion = (registratiejaar?: number | string): ManualInputVersion | undefined => {
  const year = Number(registratiejaar);

  if (!Number.isFinite(year)) {
    return undefined;
  }

  if (year < 2025) {
    return 'v1';
  }

  if (year === 2025) {
    return 'v2';
  }

  return 'v3';
};
